// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================================
   Component skin — only what antd tokens (theme.js) can't express.
   Replaces serviceProvider/premium-design.css. Sizes, colors, radii
   and control heights come from the theme, not from here.
   ============================================================ */

body {
  font-family: var(--ds-font);
  color: var(--ds-text);
  background: var(--ds-bg);
  -webkit-font-smoothing: antialiased;
  -webkit-tap-highlight-color: transparent;
  text-size-adjust: 100%;
}

/* Visible focus for keyboard users only. The panel template strips outlines from
   input/button:focus, so this has to out-rank element selectors. */
:where(a, button, input, select, textarea, [tabindex], .ant-btn, .ant-menu-item):focus-visible,
button:focus-visible,
a:focus-visible {
  outline: 2px solid var(--ds-brand) !important;
  outline-offset: 2px;
}

/* Template base (PanelAssets/custom.css) uses an unloaded "Mada" font and a low-contrast
   cyan link hover; align both with the design system. */
h1,
h2,
h3,
h4,
h5,
h6,
.ant-typography:where(h1, h2, h3, h4),
.ant-card-head-title,
.ant-modal-title,
.ant-drawer-title,
.ant-statistic-content {
  font-family: var(--ds-font-display);
  color: var(--ds-heading);
  letter-spacing: -0.01em;
}

a {
  color: var(--ds-brand-strong);
}

a:hover,
a:focus {
  color: var(--ds-brand-dark);
}

/* ── Form labels ── */
.ant-form-item-label > label,
.ant-form-item-label .ant-typography {
  font-weight: 600;
  color: var(--ds-text);
  margin: 0;
}

/* ── Modals: clean white header, scrollable body, sticky footer ── */
.ant-modal:not(.ant-modal-confirm) .ant-modal-content {
  padding: 0 !important;
  overflow: hidden;
  border-radius: var(--ds-radius-xl);
  box-shadow: var(--ds-shadow-lg);
}

.ant-modal:not(.ant-modal-confirm) .ant-modal-header {
  background: var(--ds-surface);
  padding: 20px 64px 16px 24px;
  margin: 0;
  border-bottom: 1px solid var(--ds-border-soft);
}

[dir="rtl"] .ant-modal:not(.ant-modal-confirm) .ant-modal-header {
  padding: 20px 24px 16px 64px;
}

.ant-modal:not(.ant-modal-confirm) .ant-modal-title,
.ant-modal:not(.ant-modal-confirm) .ant-modal-title h4 {
  color: var(--ds-heading);
  font-weight: 700;
  margin: 0;
}

.ant-modal:not(.ant-modal-confirm) .ant-modal-close {
  top: 14px;
  inset-inline-end: 14px;
  width: 38px;
  height: 38px;
  border-radius: 12px;
  color: var(--ds-text-2);
  background: var(--ds-surface-muted);
}

.ant-modal:not(.ant-modal-confirm) .ant-modal-close:hover {
  color: var(--ds-heading);
  background: var(--ds-border-soft);
}

.ant-modal:not(.ant-modal-confirm) .ant-modal-body {
  padding: var(--ds-space-5) var(--ds-space-6);
}

.ant-modal:not(.ant-modal-confirm) .ant-modal-footer {
  padding: var(--ds-space-3) var(--ds-space-6);
  margin: 0;
  background: var(--ds-surface-2);
  border-top: 1px solid var(--ds-border-soft);
  display: flex;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: var(--ds-space-2);
}

.ant-modal-footer .ant-btn + .ant-btn:not(.ant-dropdown-trigger) {
  margin-inline-start: 0;
}

.ant-modal-mask,
.ant-drawer-mask {
  background: rgba(19, 33, 44, 0.42) !important;
  backdrop-filter: blur(2px);
}

.ant-modal-confirm .ant-modal-content {
  border-radius: var(--ds-radius-xl);
  padding: var(--ds-space-6) !important;
}

/* ── Drawers ── */
.ant-drawer .ant-drawer-header {
  border-bottom: 1px solid var(--ds-border-soft);
}

.ant-drawer .ant-drawer-footer {
  background: var(--ds-surface-2);
  border-top: 1px solid var(--ds-border-soft);
}

/* ── Tables: framed, horizontally scrollable when they don't fit ── */
.ant-table-wrapper {
  max-width: 100%;
}

.ant-table-wrapper .ant-table {
  border: 1px solid var(--ds-border-soft);
  border-radius: var(--ds-radius-lg);
  box-shadow: var(--ds-shadow-xs);
  overflow: hidden;
}

.ant-table-wrapper .ant-table-container {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

.ant-table-thead > tr > th {
  font-size: 0.72rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  white-space: nowrap;
  border-bottom: 1px solid var(--ds-border-soft) !important;
}

.ant-table-tbody > tr > td {
  color: var(--ds-text);
}

.ant-table-tbody > tr > td:first-child {
  font-weight: 500;
  color: var(--ds-heading);
}

/* Pagination under tables and card lists */
.ant-table-pagination.ant-pagination,
.contentclass .ant-table-footer {
  margin: 0 !important;
}

.contentclass .ant-table-footer {
  background: var(--ds-surface);
  border-top: 1px solid var(--ds-border-soft);
  padding: var(--ds-space-3) var(--ds-space-4);
}

.ant-pagination .ant-pagination-item {
  border-radius: 10px;
  font-weight: 500;
}

.ant-pagination .ant-pagination-item-active {
  border-color: transparent;
  font-weight: 700;
}

.ant-pagination .ant-pagination-item-active a {
  color: var(--ds-brand-strong);
}

.ant-pagination-simple .ant-pagination-simple-pager input {
  border-radius: 8px;
}

.ant-table-tbody > tr:last-child > td {
  border-bottom: none;
}

/* ── Cards ── */
.ant-card {
  box-shadow: var(--ds-shadow-xs);
}

.ant-card-bordered {
  border-color: var(--ds-border-soft);
}

.ant-card .ant-card-head {
  border-bottom-color: var(--ds-border-soft);
}

.ant-card .ant-card-head-title {
  font-weight: 700;
}

.ant-card-hoverable:hover {
  box-shadow: var(--ds-shadow-md);
  border-color: var(--ds-border);
}

.ant-card-hoverable {
  cursor: pointer;
}

/* ── Tags: soft pills ── */
.ant-tag {
  border-radius: 999px;
  font-weight: 600;
  font-size: 0.75rem;
  padding-inline: 10px;
  line-height: 22px;
}

.ant-tag[class*="ant-tag-"]:not(.ant-tag-has-color) {
  border-color: transparent;
}

/* ── Buttons ── */
.ant-btn {
  letter-spacing: 0.005em;
}

.ant-btn-primary:not(:disabled):hover {
  transform: translateY(-1px);
}

.ant-btn-primary:not(:disabled):active {
  transform: none;
}

/* ── Inputs ── */
.ant-input-affix-wrapper.ds-search {
  border-radius: 12px;
  background: var(--ds-surface);
}

.ant-input-affix-wrapper.ds-search .ant-input-prefix {
  color: var(--ds-text-muted);
  margin-inline-end: 8px;
}

/* ── Tabs ── */
.ant-tabs-top > .ant-tabs-nav::before {
  border-bottom-color: var(--ds-border-soft);
}

.ant-tabs .ant-tabs-tab {
  font-weight: 500;
}

.ant-tabs .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
  font-weight: 600;
}

.ant-tabs-card > .ant-tabs-nav .ant-tabs-tab {
  border-radius: 10px 10px 0 0 !important;
}

/* ── Statistic ── */
.ant-statistic .ant-statistic-title {
  color: var(--ds-text-2);
  font-weight: 500;
}

.ant-statistic .ant-statistic-content {
  font-weight: 700;
  font-variant-numeric: tabular-nums;
}

/* ── Alerts ── */
.ant-alert {
  border-radius: 12px;
}

/* ── Empty ── */
.ant-empty-normal {
  color: var(--ds-text-2);
}

/* ── Descriptions ── */
.ant-descriptions-bordered .ant-descriptions-item-label {
  background: var(--ds-surface-muted);
  color: var(--ds-text-2);
  font-weight: 600;
}

/* ── Toolbar above lists (search + actions) ── */
.top-right-stuff {
  margin-bottom: var(--ds-space-4);
  width: 100%;
}

.top-right-stuff .ant-flex {
  background: var(--ds-surface);
  border: 1px solid var(--ds-border-soft);
  border-radius: var(--ds-radius-lg);
  box-shadow: var(--ds-shadow-xs);
  padding: var(--ds-space-3) var(--ds-space-4);
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: var(--ds-space-2);
}

/* ── Rich text (Quill) ── */
.ql-toolbar.ql-snow {
  border: 1px solid var(--ds-border) !important;
  border-radius: var(--ds-radius-md) var(--ds-radius-md) 0 0;
  background: var(--ds-surface-muted);
}

.ql-container.ql-snow {
  border: 1px solid var(--ds-border) !important;
  border-top: none !important;
  border-radius: 0 0 var(--ds-radius-md) var(--ds-radius-md);
  font-size: 0.9rem;
}

.ql-editor {
  min-height: 120px;
  color: var(--ds-text);
}

/* ── Legacy Bootstrap form controls, matched to antd fields ── */
.form-control,
select.form-control {
  min-height: 40px;
  border: 1px solid var(--ds-border);
  border-radius: var(--ds-radius-md);
  color: var(--ds-text);
  transition:
    border-color 0.2s,
    box-shadow 0.2s;
}

.form-control:focus {
  border-color: var(--ds-brand);
  box-shadow: var(--ds-focus-ring);
  outline: none;
}

/* ── Grid safety: flex children may shrink, so wide content scrolls instead of the page ── */
.ant-col {
  min-width: 0;
}

/* ── Scrollbars (desktop pointers only) ── */
@media (hover: hover) and (pointer: fine) {
  ::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }
  ::-webkit-scrollbar-track {
    background: transparent;
  }
  ::-webkit-scrollbar-thumb {
    background: #c9d5dd;
    border-radius: 10px;
    border: 2px solid transparent;
    background-clip: content-box;
  }
  ::-webkit-scrollbar-thumb:hover {
    background: var(--ds-brand);
    background-clip: content-box;
  }
}

/* ── Row "more actions" trigger (commons/Dropdowns/DropdownComp) ── */
.row-actions-trigger {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  padding: 0;
  border: 0;
  border-radius: var(--ds-radius-md);
  background: transparent;
  color: var(--ds-text-2);
  font-size: 20px;
  cursor: pointer;
}

.row-actions-trigger:hover {
  background: var(--ds-surface-muted);
  color: var(--ds-brand-dark);
}

.row-actions-trigger svg {
  cursor: inherit;
}

/* RTL tables: numbers, phone numbers, IBANs and emails have no strong direction of their own and
   get reordered ("+49 151 …" became "… 151 49+"). plaintext picks each cell's direction from its
   own content, so Arabic stays RTL while digits/Latin render LTR; alignment is unaffected. */
[dir="rtl"] .ant-table-cell,
[dir="rtl"] .ant-descriptions-item-content {
  unicode-bidi: plaintext;
}
`, "",{"version":3,"sources":["webpack://./src/design-system/components.css"],"names":[],"mappings":"AAAA;;;;iEAIiE;;AAEjE;EACE,2BAA2B;EAC3B,qBAAqB;EACrB,wBAAwB;EACxB,mCAAmC;EACnC,wCAAwC;EACxC,sBAAsB;AACxB;;AAEA;mEACmE;AACnE;;;EAGE,6CAA6C;EAC7C,mBAAmB;AACrB;;AAEA;wDACwD;AACxD;;;;;;;;;;;EAWE,mCAAmC;EACnC,wBAAwB;EACxB,uBAAuB;AACzB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;;EAEE,2BAA2B;AAC7B;;AAEA,sBAAsB;AACtB;;EAEE,gBAAgB;EAChB,qBAAqB;EACrB,SAAS;AACX;;AAEA,qEAAqE;AACrE;EACE,qBAAqB;EACrB,gBAAgB;EAChB,kCAAkC;EAClC,+BAA+B;AACjC;;AAEA;EACE,6BAA6B;EAC7B,4BAA4B;EAC5B,SAAS;EACT,8CAA8C;AAChD;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;;EAEE,wBAAwB;EACxB,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,SAAS;EACT,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,mCAAmC;AACrC;;AAEA;EACE,wBAAwB;EACxB,iCAAiC;AACnC;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,4CAA4C;EAC5C,SAAS;EACT,+BAA+B;EAC/B,2CAA2C;EAC3C,aAAa;EACb,yBAAyB;EACzB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;EAEE,6CAA6C;EAC7C,0BAA0B;AAC5B;;AAEA;EACE,kCAAkC;EAClC,qCAAqC;AACvC;;AAEA,kBAAkB;AAClB;EACE,8CAA8C;AAChD;;AAEA;EACE,+BAA+B;EAC/B,2CAA2C;AAC7C;;AAEA,sEAAsE;AACtE;EACE,eAAe;AACjB;;AAEA;EACE,uCAAuC;EACvC,kCAAkC;EAClC,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;EACnB,yDAAyD;AAC3D;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA,2CAA2C;AAC3C;;EAEE,oBAAoB;AACtB;;AAEA;EACE,6BAA6B;EAC7B,2CAA2C;EAC3C,4CAA4C;AAC9C;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,gBAAgB;AAChB;EACE,+BAA+B;AACjC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B,8BAA8B;AAChC;;AAEA;EACE,eAAe;AACjB;;AAEA,2BAA2B;AAC3B;EACE,oBAAoB;EACpB,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,kBAAkB;AAClB;EACE,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,eAAe;AACjB;;AAEA,iBAAiB;AACjB;EACE,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;EAC3B,sBAAsB;AACxB;;AAEA,eAAe;AACf;EACE,0CAA0C;AAC5C;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,uCAAuC;AACzC;;AAEA,oBAAoB;AACpB;EACE,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA,iBAAiB;AACjB;EACE,mBAAmB;AACrB;;AAEA,gBAAgB;AAChB;EACE,uBAAuB;AACzB;;AAEA,uBAAuB;AACvB;EACE,mCAAmC;EACnC,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA,iDAAiD;AACjD;EACE,gCAAgC;EAChC,WAAW;AACb;;AAEA;EACE,6BAA6B;EAC7B,uCAAuC;EACvC,kCAAkC;EAClC,+BAA+B;EAC/B,4CAA4C;EAC5C,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;EACf,sBAAsB;AACxB;;AAEA,4BAA4B;AAC5B;EACE,6CAA6C;EAC7C,0DAA0D;EAC1D,mCAAmC;AACrC;;AAEA;EACE,6CAA6C;EAC7C,2BAA2B;EAC3B,0DAA0D;EAC1D,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA,iEAAiE;AACjE;;EAEE,gBAAgB;EAChB,kCAAkC;EAClC,kCAAkC;EAClC,qBAAqB;EACrB;;mBAEiB;AACnB;;AAEA;EACE,6BAA6B;EAC7B,gCAAgC;EAChC,aAAa;AACf;;AAEA,6FAA6F;AAC7F;EACE,YAAY;AACd;;AAEA,6CAA6C;AAC7C;EACE;IACE,UAAU;IACV,WAAW;EACb;EACA;IACE,uBAAuB;EACzB;EACA;IACE,mBAAmB;IACnB,mBAAmB;IACnB,6BAA6B;IAC7B,4BAA4B;EAC9B;EACA;IACE,2BAA2B;IAC3B,4BAA4B;EAC9B;AACF;;AAEA,sEAAsE;AACtE;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,SAAS;EACT,kCAAkC;EAClC,uBAAuB;EACvB,uBAAuB;EACvB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,mCAAmC;EACnC,2BAA2B;AAC7B;;AAEA;EACE,eAAe;AACjB;;AAEA;;6FAE6F;AAC7F;;EAEE,uBAAuB;AACzB","sourcesContent":["/* ============================================================\n   Component skin — only what antd tokens (theme.js) can't express.\n   Replaces serviceProvider/premium-design.css. Sizes, colors, radii\n   and control heights come from the theme, not from here.\n   ============================================================ */\n\nbody {\n  font-family: var(--ds-font);\n  color: var(--ds-text);\n  background: var(--ds-bg);\n  -webkit-font-smoothing: antialiased;\n  -webkit-tap-highlight-color: transparent;\n  text-size-adjust: 100%;\n}\n\n/* Visible focus for keyboard users only. The panel template strips outlines from\n   input/button:focus, so this has to out-rank element selectors. */\n:where(a, button, input, select, textarea, [tabindex], .ant-btn, .ant-menu-item):focus-visible,\nbutton:focus-visible,\na:focus-visible {\n  outline: 2px solid var(--ds-brand) !important;\n  outline-offset: 2px;\n}\n\n/* Template base (PanelAssets/custom.css) uses an unloaded \"Mada\" font and a low-contrast\n   cyan link hover; align both with the design system. */\nh1,\nh2,\nh3,\nh4,\nh5,\nh6,\n.ant-typography:where(h1, h2, h3, h4),\n.ant-card-head-title,\n.ant-modal-title,\n.ant-drawer-title,\n.ant-statistic-content {\n  font-family: var(--ds-font-display);\n  color: var(--ds-heading);\n  letter-spacing: -0.01em;\n}\n\na {\n  color: var(--ds-brand-strong);\n}\n\na:hover,\na:focus {\n  color: var(--ds-brand-dark);\n}\n\n/* ── Form labels ── */\n.ant-form-item-label > label,\n.ant-form-item-label .ant-typography {\n  font-weight: 600;\n  color: var(--ds-text);\n  margin: 0;\n}\n\n/* ── Modals: clean white header, scrollable body, sticky footer ── */\n.ant-modal:not(.ant-modal-confirm) .ant-modal-content {\n  padding: 0 !important;\n  overflow: hidden;\n  border-radius: var(--ds-radius-xl);\n  box-shadow: var(--ds-shadow-lg);\n}\n\n.ant-modal:not(.ant-modal-confirm) .ant-modal-header {\n  background: var(--ds-surface);\n  padding: 20px 64px 16px 24px;\n  margin: 0;\n  border-bottom: 1px solid var(--ds-border-soft);\n}\n\n[dir=\"rtl\"] .ant-modal:not(.ant-modal-confirm) .ant-modal-header {\n  padding: 20px 24px 16px 64px;\n}\n\n.ant-modal:not(.ant-modal-confirm) .ant-modal-title,\n.ant-modal:not(.ant-modal-confirm) .ant-modal-title h4 {\n  color: var(--ds-heading);\n  font-weight: 700;\n  margin: 0;\n}\n\n.ant-modal:not(.ant-modal-confirm) .ant-modal-close {\n  top: 14px;\n  inset-inline-end: 14px;\n  width: 38px;\n  height: 38px;\n  border-radius: 12px;\n  color: var(--ds-text-2);\n  background: var(--ds-surface-muted);\n}\n\n.ant-modal:not(.ant-modal-confirm) .ant-modal-close:hover {\n  color: var(--ds-heading);\n  background: var(--ds-border-soft);\n}\n\n.ant-modal:not(.ant-modal-confirm) .ant-modal-body {\n  padding: var(--ds-space-5) var(--ds-space-6);\n}\n\n.ant-modal:not(.ant-modal-confirm) .ant-modal-footer {\n  padding: var(--ds-space-3) var(--ds-space-6);\n  margin: 0;\n  background: var(--ds-surface-2);\n  border-top: 1px solid var(--ds-border-soft);\n  display: flex;\n  justify-content: flex-end;\n  flex-wrap: wrap;\n  gap: var(--ds-space-2);\n}\n\n.ant-modal-footer .ant-btn + .ant-btn:not(.ant-dropdown-trigger) {\n  margin-inline-start: 0;\n}\n\n.ant-modal-mask,\n.ant-drawer-mask {\n  background: rgba(19, 33, 44, 0.42) !important;\n  backdrop-filter: blur(2px);\n}\n\n.ant-modal-confirm .ant-modal-content {\n  border-radius: var(--ds-radius-xl);\n  padding: var(--ds-space-6) !important;\n}\n\n/* ── Drawers ── */\n.ant-drawer .ant-drawer-header {\n  border-bottom: 1px solid var(--ds-border-soft);\n}\n\n.ant-drawer .ant-drawer-footer {\n  background: var(--ds-surface-2);\n  border-top: 1px solid var(--ds-border-soft);\n}\n\n/* ── Tables: framed, horizontally scrollable when they don't fit ── */\n.ant-table-wrapper {\n  max-width: 100%;\n}\n\n.ant-table-wrapper .ant-table {\n  border: 1px solid var(--ds-border-soft);\n  border-radius: var(--ds-radius-lg);\n  box-shadow: var(--ds-shadow-xs);\n  overflow: hidden;\n}\n\n.ant-table-wrapper .ant-table-container {\n  overflow-x: auto;\n  -webkit-overflow-scrolling: touch;\n}\n\n.ant-table-thead > tr > th {\n  font-size: 0.72rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  white-space: nowrap;\n  border-bottom: 1px solid var(--ds-border-soft) !important;\n}\n\n.ant-table-tbody > tr > td {\n  color: var(--ds-text);\n}\n\n.ant-table-tbody > tr > td:first-child {\n  font-weight: 500;\n  color: var(--ds-heading);\n}\n\n/* Pagination under tables and card lists */\n.ant-table-pagination.ant-pagination,\n.contentclass .ant-table-footer {\n  margin: 0 !important;\n}\n\n.contentclass .ant-table-footer {\n  background: var(--ds-surface);\n  border-top: 1px solid var(--ds-border-soft);\n  padding: var(--ds-space-3) var(--ds-space-4);\n}\n\n.ant-pagination .ant-pagination-item {\n  border-radius: 10px;\n  font-weight: 500;\n}\n\n.ant-pagination .ant-pagination-item-active {\n  border-color: transparent;\n  font-weight: 700;\n}\n\n.ant-pagination .ant-pagination-item-active a {\n  color: var(--ds-brand-strong);\n}\n\n.ant-pagination-simple .ant-pagination-simple-pager input {\n  border-radius: 8px;\n}\n\n.ant-table-tbody > tr:last-child > td {\n  border-bottom: none;\n}\n\n/* ── Cards ── */\n.ant-card {\n  box-shadow: var(--ds-shadow-xs);\n}\n\n.ant-card-bordered {\n  border-color: var(--ds-border-soft);\n}\n\n.ant-card .ant-card-head {\n  border-bottom-color: var(--ds-border-soft);\n}\n\n.ant-card .ant-card-head-title {\n  font-weight: 700;\n}\n\n.ant-card-hoverable:hover {\n  box-shadow: var(--ds-shadow-md);\n  border-color: var(--ds-border);\n}\n\n.ant-card-hoverable {\n  cursor: pointer;\n}\n\n/* ── Tags: soft pills ── */\n.ant-tag {\n  border-radius: 999px;\n  font-weight: 600;\n  font-size: 0.75rem;\n  padding-inline: 10px;\n  line-height: 22px;\n}\n\n.ant-tag[class*=\"ant-tag-\"]:not(.ant-tag-has-color) {\n  border-color: transparent;\n}\n\n/* ── Buttons ── */\n.ant-btn {\n  letter-spacing: 0.005em;\n}\n\n.ant-btn-primary:not(:disabled):hover {\n  transform: translateY(-1px);\n}\n\n.ant-btn-primary:not(:disabled):active {\n  transform: none;\n}\n\n/* ── Inputs ── */\n.ant-input-affix-wrapper.ds-search {\n  border-radius: 12px;\n  background: var(--ds-surface);\n}\n\n.ant-input-affix-wrapper.ds-search .ant-input-prefix {\n  color: var(--ds-text-muted);\n  margin-inline-end: 8px;\n}\n\n/* ── Tabs ── */\n.ant-tabs-top > .ant-tabs-nav::before {\n  border-bottom-color: var(--ds-border-soft);\n}\n\n.ant-tabs .ant-tabs-tab {\n  font-weight: 500;\n}\n\n.ant-tabs .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {\n  font-weight: 600;\n}\n\n.ant-tabs-card > .ant-tabs-nav .ant-tabs-tab {\n  border-radius: 10px 10px 0 0 !important;\n}\n\n/* ── Statistic ── */\n.ant-statistic .ant-statistic-title {\n  color: var(--ds-text-2);\n  font-weight: 500;\n}\n\n.ant-statistic .ant-statistic-content {\n  font-weight: 700;\n  font-variant-numeric: tabular-nums;\n}\n\n/* ── Alerts ── */\n.ant-alert {\n  border-radius: 12px;\n}\n\n/* ── Empty ── */\n.ant-empty-normal {\n  color: var(--ds-text-2);\n}\n\n/* ── Descriptions ── */\n.ant-descriptions-bordered .ant-descriptions-item-label {\n  background: var(--ds-surface-muted);\n  color: var(--ds-text-2);\n  font-weight: 600;\n}\n\n/* ── Toolbar above lists (search + actions) ── */\n.top-right-stuff {\n  margin-bottom: var(--ds-space-4);\n  width: 100%;\n}\n\n.top-right-stuff .ant-flex {\n  background: var(--ds-surface);\n  border: 1px solid var(--ds-border-soft);\n  border-radius: var(--ds-radius-lg);\n  box-shadow: var(--ds-shadow-xs);\n  padding: var(--ds-space-3) var(--ds-space-4);\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  flex-wrap: wrap;\n  gap: var(--ds-space-2);\n}\n\n/* ── Rich text (Quill) ── */\n.ql-toolbar.ql-snow {\n  border: 1px solid var(--ds-border) !important;\n  border-radius: var(--ds-radius-md) var(--ds-radius-md) 0 0;\n  background: var(--ds-surface-muted);\n}\n\n.ql-container.ql-snow {\n  border: 1px solid var(--ds-border) !important;\n  border-top: none !important;\n  border-radius: 0 0 var(--ds-radius-md) var(--ds-radius-md);\n  font-size: 0.9rem;\n}\n\n.ql-editor {\n  min-height: 120px;\n  color: var(--ds-text);\n}\n\n/* ── Legacy Bootstrap form controls, matched to antd fields ── */\n.form-control,\nselect.form-control {\n  min-height: 40px;\n  border: 1px solid var(--ds-border);\n  border-radius: var(--ds-radius-md);\n  color: var(--ds-text);\n  transition:\n    border-color 0.2s,\n    box-shadow 0.2s;\n}\n\n.form-control:focus {\n  border-color: var(--ds-brand);\n  box-shadow: var(--ds-focus-ring);\n  outline: none;\n}\n\n/* ── Grid safety: flex children may shrink, so wide content scrolls instead of the page ── */\n.ant-col {\n  min-width: 0;\n}\n\n/* ── Scrollbars (desktop pointers only) ── */\n@media (hover: hover) and (pointer: fine) {\n  ::-webkit-scrollbar {\n    width: 8px;\n    height: 8px;\n  }\n  ::-webkit-scrollbar-track {\n    background: transparent;\n  }\n  ::-webkit-scrollbar-thumb {\n    background: #c9d5dd;\n    border-radius: 10px;\n    border: 2px solid transparent;\n    background-clip: content-box;\n  }\n  ::-webkit-scrollbar-thumb:hover {\n    background: var(--ds-brand);\n    background-clip: content-box;\n  }\n}\n\n/* ── Row \"more actions\" trigger (commons/Dropdowns/DropdownComp) ── */\n.row-actions-trigger {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 40px;\n  height: 40px;\n  padding: 0;\n  border: 0;\n  border-radius: var(--ds-radius-md);\n  background: transparent;\n  color: var(--ds-text-2);\n  font-size: 20px;\n  cursor: pointer;\n}\n\n.row-actions-trigger:hover {\n  background: var(--ds-surface-muted);\n  color: var(--ds-brand-dark);\n}\n\n.row-actions-trigger svg {\n  cursor: inherit;\n}\n\n/* RTL tables: numbers, phone numbers, IBANs and emails have no strong direction of their own and\n   get reordered (\"+49 151 …\" became \"… 151 49+\"). plaintext picks each cell's direction from its\n   own content, so Arabic stays RTL while digits/Latin render LTR; alignment is unaffected. */\n[dir=\"rtl\"] .ant-table-cell,\n[dir=\"rtl\"] .ant-descriptions-item-content {\n  unicode-bidi: plaintext;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
